import React, { useRef, useState } from 'react'
import { MapContainer,Marker,Popup,TileLayer } from 'react-leaflet'
import { Map } from 'leaflet'
import l from 'leaflet'
import 'leaflet/dist/leaflet.css'
const My = () => {
    const mapref=useRef()
    const markericon=new l.icon({
      iconUrl:'https://unpkg.com/leaflet@1.6.0/dist/images/marker-icon-2x.png',
      iconSize:[25,35],
      iconAnchor:[92,35],
      popupAnchor:[-79,-30]
    })
  return (
    <div>
      <MapContainer center={[6.6727413,-1.5630001]} zoom={12} ref={mapref} >
        <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' />
        <Marker position={[6.6721726,-1.5619298]} icon={markericon} >
          <Popup>
            <h4>frontline</h4>
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  )
}

export default My
